import { memo, useEffect, useRef } from 'react';

declare global {
  interface Window {
    ghComponentAdded: boolean;
  }
}

const GamingHub = ({ options, passiveMode }: { options: any; passiveMode?: boolean }) => {
  const ghComponentAdded = useRef(window.ghComponentAdded);
  useEffect(() => {
    window.ghComponentAdded = ghComponentAdded.current;
  }, [ghComponentAdded]);
  if (!options.gamingHubComponentUrl || ghComponentAdded.current) return null;

  return (
    <>
      <script src={options.gamingHubComponentUrl} async />
      {/* @ts-expect-error: g-h-c is not a valid HTML element, but it is in this context */}
      <g-h-c
        ref={() => {
          ghComponentAdded.current = true;
        }}
        passivemode={`${!!passiveMode}`}
        language={options.language}
        comp={options.competition}
        season={options.season}
        game={options.game}
      />
    </>
  );
};

export default memo(GamingHub);
